module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921114151_T.c0244aa7.jpg";